import { rewriteOriginUrls } from './originRewrite.js'
import { safeParseJson } from './bigintSafe.js'
var websock = null;
let rec; //断线重连后，延迟5秒重新创建WebSocket连接  rec用来存储延迟请求的代码
let isConnect = false; //连接标识 避免重复连接
let connectCallBack = null;
let messageCallBack = null;
let closeCallBack = null
let devId = Math.floor(Math.random() * 1000000)

// WS 地址支持两种配置：完整 ws(s):// 地址直接用；只配路径（如 "/im"）则按当前页面
// origin 拼接 —— 这样域名访问走域名、纯IP应急通道访问自动跟随IP，无需重新打包
let buildWsUrl = (wsurl) => {
	if (!wsurl || wsurl.indexOf('ws://') === 0 || wsurl.indexOf('wss://') === 0) {
		return wsurl;
	}
	let proto = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
	return proto + window.location.host + wsurl;
}


let connect = (wsurl, accessToken) => {
	try {
		if (isConnect) {
			return;
		}
		console.log("连接WebSocket");
		websock = new WebSocket(buildWsUrl(wsurl));
		websock.onmessage = function (e) {
			let sendInfo = safeParseJson(e.data)
			if (sendInfo.cmd == 0) {
				heartCheck.start()
				// 登录成功才算真正完成连接
				connectCallBack && connectCallBack();
				console.log('WebSocket登录成功')
			} else if (sendInfo.cmd == 1) {
				// 重新开启心跳定时
				heartCheck.reset();
			} else {
				// 其他消息转发出去（消息体里的图片/文件URL写死了域名，改写成当前origin）
				console.log("收到消息:", sendInfo);
				messageCallBack && messageCallBack(sendInfo.cmd, rewriteOriginUrls(sendInfo.data))
			}
		}
		websock.onclose = function (e) {
			console.log('WebSocket连接关闭')
			isConnect = false; //断开后修改标识
			closeCallBack && closeCallBack(e);
		}
		websock.onopen = function () {
			console.log("WebSocket连接成功");
			isConnect = true;
			// 发送登录命令
			let loginInfo = {
				cmd: 0,
				data: {
					accessToken: accessToken,
					devId: devId
				}
			};
			websock.send(JSON.stringify(loginInfo));
		}

		// 连接发生错误的回调方法
		websock.onerror = function (e) {
			console.log('WebSocket连接发生错误:{}', e)
			close(3000);
			isConnect = false;
			closeCallBack && closeCallBack(e);
		}
	} catch (e) {
		console.log("尝试创建连接失败");
		reconnect(wsurl, accessToken); //如果无法连接上webSocket 那么重新连接！可能会因为服务器重新部署，或者短暂断网等导致无法创建连接
	}
};

//定义重连函数
let reconnect = (wsurl, accessToken) => {
	console.log("尝试重新连接");
	if (isConnect) {
		//如果已经连上就不在重连了
		return;
	}
	rec && clearTimeout(rec);
	rec = setTimeout(function () { // 延迟5秒重连  避免过多次过频繁请求重连
		connect(wsurl, accessToken);
	}, 15000);
};
//设置关闭连接
let close = (code) => {
	websock && websock.close(code);
};


//心跳设置
// 说明: 后端 reader-idle 与在线状态key TTL 均为600s, 心跳只需远小于该值即可保活。
// 旧值(心跳5s/超时15s)过于激进: 浏览器切到后台会节流JS定时器, 心跳链停摆时15s超时
// 定时器会误判"服务端无响应"而主动close, 触发断网保护清空内存会话+重连, 表现为"消息自己消失"。
// 放宽为心跳25s/超时60s, 并在页面隐藏时不以被节流的定时器为准强制断开。
let heartCheck = {
	timeout: 25000, //每25秒发送一次心跳包
	timeoutObj: null, //延时发送消息对象（启动心跳新建这个对象，收到消息后重置对象）
	serverTimeoutObj: null, //心跳超时检测对象（发送心跳后启动，收到消息后清除，超时则关闭连接触发重连）
	start: function () {
		if (isConnect) {
			console.log('发送WebSocket心跳')
			let heartBeat = {
				cmd: 1,
				data: {}
			};
			websock.send(JSON.stringify(heartBeat))
			// 发送心跳后启动超时检测：60秒内未收到服务端任何消息才判定连接失效
			clearTimeout(this.serverTimeoutObj);
			this.serverTimeoutObj = setTimeout(function () {
				// 页面在后台时定时器被浏览器节流, 此时的"超时"不可信: 不强制关闭,
				// 待切回前台由 visibilitychange 主动补心跳校验; 真正的断连会由 onclose 捕获
				if (typeof document !== 'undefined' && document.visibilityState === 'hidden') {
					console.log('页面处于后台, 心跳超时定时器可能被节流, 跳过强制关闭');
					return;
				}
				console.log('WebSocket心跳超时，服务端无响应，关闭连接触发重连');
				websock.close();
			}, 60000);
		}
	},
	reset: function () {
		clearTimeout(this.timeoutObj);
		// 收到服务端消息，说明连接正常，清除超时检测定时器
		clearTimeout(this.serverTimeoutObj);
		this.serverTimeoutObj = null;
		this.timeoutObj = setTimeout(function () {
			heartCheck.start();
		}, this.timeout);

	}
};

// 页面从后台切回前台: 后台期间定时器被节流、心跳可能长时间未发, 切回时立即补一次心跳并
// 重置超时检测, 快速确认连接可用(若已失效则服务端无响应, 60s后触发关闭重连)
if (typeof document !== 'undefined' && !document.__imWsVisibilityBound) {
	document.__imWsVisibilityBound = true;
	document.addEventListener('visibilitychange', function () {
		if (document.visibilityState === 'visible' && isConnect) {
			heartCheck.reset();
			heartCheck.start();
		}
	});
}



// 实际调用的方法
let sendMessage = (agentData, retryCount) => {
	retryCount = retryCount || 0;
	if (websock.readyState === websock.OPEN) {
		// 若是ws开启状态
		websock.send(JSON.stringify(agentData))
	} else if (websock.readyState === websock.CONNECTING) {
		// 若是 正在开启状态，则等待1s后重新调用
		if (retryCount >= 3) {
			console.error('WebSocket发送消息失败: 连接正在建立，已超过最大重试次数(3次)')
			return;
		}
		setTimeout(function () {
			sendMessage(agentData, retryCount + 1)
		}, 1000)
	} else {
		// 若未开启 ，则等待1s后重新调用
		if (retryCount >= 3) {
			console.error('WebSocket发送消息失败: 连接未开启，已超过最大重试次数(3次)')
			return;
		}
		setTimeout(function () {
			sendMessage(agentData, retryCount + 1)
		}, 1000)
	}
}

let onConnect = (callback) => {
	connectCallBack = callback;
}

let onMessage = (callback) => {
	messageCallBack = callback;
}


let onClose = (callback) => {
	closeCallBack = callback;
}
// 将方法暴露出去
export {
	connect,
	reconnect,
	close,
	sendMessage,
	onConnect,
	onMessage,
	onClose,
}
